/* Akış Tema — base.js
 * Sözleşme (SEFLIK.md):
 *  - window.Tema.sepeteEkle(items, { ac, sessiz }) → /cart/add.js (sessiz: hata toast'ı yok, çağıran kendisi gösterir), sonra 'cart:refresh' (detail.cart) + 'cart:open' yayar. Promise<cart> döner.
 *  - document 'cart:refresh' → header sepet sayacı ([data-cart-bubble]) güncellenir; çekmece (A3) kendini yeniden çizer.
 *  - document 'cart:open' → çekmece açılır (A3 dinler). Çekmece yoksa /cart'a gider.
 *  - Yardımcılar: Tema.paraBicimle(kurus), Tema.sepetiGetir(), Tema.bildir(metin), Tema.yay(ad, detail).
 */
(() => {
  const Tema = (window.Tema = window.Tema || {});
  const A = Object.assign({ kok: '/', sepet: '/cart', sepeteEkle: '/cart/add', paraBicimi: '{{amount}} TL', cekmece: true }, Tema.ayarlar || {});
  const M = Object.assign({ ekleniyor: 'Ekleniyor…', eklendi: 'Sepete eklendi', eklemeHatasi: 'Ürün sepete eklenemedi.', sepeteEkle: 'Sepete ekle' }, Tema.metin || {});
  Tema.ayarlar = A;
  Tema.metin = M;
  const azHareket = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Tema.azHareket = azHareket;

  /* ---------- Olay yolu ---------- */
  Tema.yay = (ad, detail = {}) => document.dispatchEvent(new CustomEvent(ad, { detail }));

  /* ---------- Para biçimi (Shopify money_format) ---------- */
  Tema.paraBicimle = (kurus, bicim = A.paraBicimi) => {
    const n = Number(kurus) || 0;
    const sayi = (v, ondalik, binlik, ayrac) => {
      const [tam, kesir] = (v / 100).toFixed(ondalik).split('.');
      return tam.replace(/\B(?=(\d{3})+(?!\d))/g, binlik) + (kesir ? ayrac + kesir : '');
    };
    return String(bicim).replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return sayi(n, 0, ',', '.');
        case 'amount_with_comma_separator': return sayi(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sayi(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sayi(n, 2, "'", '.');
        default: return sayi(n, 2, ',', '.');
      }
    });
  };

  /* ---------- Sepet ---------- */
  const kok = A.kok.endsWith('/') ? A.kok : A.kok + '/';
  Tema.sepetiGetir = () => fetch(kok + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

  Tema.sepeteEkle = async (items, secenek = {}) => {
    const liste = (Array.isArray(items) ? items : [items])
      .filter(Boolean)
      .map((i) => ({ id: Number(i.id), quantity: Math.max(1, Number(i.quantity) || 1), ...(i.properties ? { properties: i.properties } : {}), ...(i.selling_plan ? { selling_plan: i.selling_plan } : {}) }));
    if (!liste.length) throw new Error('Tema.sepeteEkle: ürün yok');
    const yanit = await fetch(A.sepeteEkle + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: liste }),
    });
    const veri = await yanit.json().catch(() => ({}));
    if (!yanit.ok || veri.status) {
      const mesaj = veri.description || veri.message || M.eklemeHatasi;
      Tema.yay('cart:error', { message: mesaj, items: liste });
      if (!secenek.sessiz) Tema.bildir(mesaj, 'hata');
      throw new Error(mesaj);
    }
    const sepet = await Tema.sepetiGetir();
    Tema.yay('cart:refresh', { cart: sepet, added: veri.items || liste });
    if (secenek.ac !== false) Tema.sepetiAc();
    return sepet;
  };

  Tema.cekmeceVar = () => !!document.querySelector('[data-cart-drawer]');
  Tema.sepetiAc = () => {
    if (A.cekmece && Tema.cekmeceVar()) Tema.yay('cart:open');
    else if (!document.body.classList.contains('template-cart')) window.location.href = A.sepet;
  };

  // Sayaç: detail.cart varsa onu kullan, yoksa /cart.js çek.
  document.addEventListener('cart:refresh', async (e) => {
    let sepet = e.detail && e.detail.cart;
    if (!sepet) { try { sepet = await Tema.sepetiGetir(); } catch (_) { return; } }
    document.querySelectorAll('[data-cart-bubble]').forEach((el) => {
      el.textContent = sepet.item_count;
      el.hidden = sepet.item_count === 0;
      if (!azHareket()) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  });

  // cart.js sayacı [data-cart-count] ile doğrudan da yazabilir: balonun görünürlüğünü metne göre eşitle.
  const balonIzle = () => {
    document.querySelectorAll('[data-cart-bubble]').forEach((el) => {
      if (el.dataset.izleniyor) return;
      el.dataset.izleniyor = '1';
      new MutationObserver(() => { el.hidden = (parseInt(el.textContent, 10) || 0) === 0; }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  };
  Tema.balonIzle = balonIzle;

  /* ---------- Bildirim (toast) ---------- */
  let toastZaman;
  Tema.bildir = (metin, tur = 'bilgi') => {
    const el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = metin;
    el.dataset.tur = tur;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastZaman);
    toastZaman = setTimeout(() => { el.classList.remove('is-visible'); setTimeout(() => (el.hidden = true), 300); }, 3200);
  };

  /* ---------- Tıklama delegasyonu ---------- */
  document.addEventListener('click', async (e) => {
    // Header sepet bağlantısı ([data-cart-open]) → çekmeceyi cart.js (A3) açar; burada müdahale yok.

    // Ürün kartı hızlı ekle
    const btn = e.target.closest('[data-quick-add]');
    if (btn && !btn.disabled) {
      e.preventDefault();
      const etiket = btn.querySelector('[data-quick-add-label]') || btn;
      const eski = etiket.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      etiket.textContent = M.ekleniyor;
      try {
        await Tema.sepeteEkle([{ id: btn.dataset.quickAdd, quantity: Number(btn.dataset.quantity) || 1 }]);
        etiket.textContent = M.eklendi;
        btn.classList.add('is-added');
        if (!(A.cekmece && Tema.cekmeceVar())) Tema.bildir(M.eklendi);
        setTimeout(() => { etiket.textContent = eski; btn.classList.remove('is-added'); }, 1800);
      } catch (_) {
        etiket.textContent = eski;
      } finally {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
  });

  /* ---------- Header: kaydırınca küçülme + mobil çekmece ---------- */
  const headerKur = () => {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const kapsayici = header.closest('.shopify-section') || header;
    const yapiskan = header.dataset.sticky === 'true';
    if (yapiskan) kapsayici.classList.add('header-sticky');
    let son = 0, bekliyor = false;
    const guncelle = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 24);
      if (yapiskan && header.dataset.hide === 'true') kapsayici.classList.toggle('is-hidden', y > son && y > 240);
      son = y; bekliyor = false;
    };
    window.addEventListener('scroll', () => { if (!bekliyor) { bekliyor = true; requestAnimationFrame(guncelle); } }, { passive: true });
    guncelle();
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');

    const dlg = header.querySelector('[data-menu-drawer]');
    const ac = header.querySelector('[data-menu-open]');
    if (dlg && ac) {
      ac.addEventListener('click', () => { dlg.showModal(); ac.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('is-locked'); });
      const kapat = () => {
        if (!dlg.open) return;
        if (azHareket()) { dlg.close(); return; }
        dlg.classList.add('is-closing');
        setTimeout(() => { dlg.classList.remove('is-closing'); dlg.close(); }, 260);
      };
      dlg.addEventListener('close', () => { ac.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('is-locked'); ac.focus(); });
      dlg.addEventListener('cancel', (e) => { e.preventDefault(); kapat(); });
      dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-menu-close]')) kapat(); });
    }
  };

  /* ---------- Duyuru: dönen mesajlar + gerçek bitiş tarihi sayacı ---------- */
  const duyuruKur = () => {
    document.querySelectorAll('[data-announcement]').forEach((bar) => {
      const msgs = [...bar.querySelectorAll('[data-announcement-msg]')];
      if (msgs.length > 1 && !azHareket()) {
        let i = 0;
        const sure = Number(bar.dataset.speed || 5) * 1000;
        let zaman = setInterval(() => {
          msgs[i].classList.remove('is-active'); msgs[i].setAttribute('aria-hidden', 'true');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('is-active'); msgs[i].removeAttribute('aria-hidden');
        }, sure);
        bar.addEventListener('mouseenter', () => clearInterval(zaman));
        bar.addEventListener('focusin', () => clearInterval(zaman));
      }
      const sayac = bar.querySelector('[data-countdown]');
      if (!sayac) return;
      const bitis = Date.parse(sayac.dataset.countdown);
      if (Number.isNaN(bitis)) { sayac.remove(); return; }
      const parca = (k) => sayac.querySelector(`[data-cd="${k}"]`);
      const iki = (n) => String(n).padStart(2, '0');
      const tik = () => {
        const kalan = bitis - Date.now();
        if (kalan <= 0) { sayac.remove(); return false; }
        const s = Math.floor(kalan / 1000);
        parca('d').textContent = Math.floor(s / 86400);
        parca('h').textContent = iki(Math.floor((s % 86400) / 3600));
        parca('m').textContent = iki(Math.floor((s % 3600) / 60));
        parca('s').textContent = iki(s % 60);
        sayac.hidden = false;
        return true;
      };
      if (tik()) { const t = setInterval(() => { if (!tik()) clearInterval(t); }, 1000); }
    });
  };

  /* ---------- Kaydırınca belirme: [data-reveal] (gecikme: style="--d: 2") ---------- */
  Tema.belirmeKur = (kok = document) => {
    const els = kok.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!document.body.classList.contains('has-anim') || azHareket() || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((girdiler) => {
      girdiler.forEach((g) => { if (g.isIntersecting) { g.target.classList.add('is-in'); io.unobserve(g.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  };

  /* ---------- Yatay kaydırıcı: [data-slider] içinde [data-slider-track], [data-slider-prev|next] ---------- */
  Tema.kaydiriciKur = (kok = document) => {
    kok.querySelectorAll('[data-slider]:not([data-slider-ok])').forEach((s) => {
      s.setAttribute('data-slider-ok', '');
      const track = s.querySelector('[data-slider-track]');
      const prev = s.querySelector('[data-slider-prev]');
      const next = s.querySelector('[data-slider-next]');
      if (!track) return;
      const adim = () => { const k = track.firstElementChild; return k ? k.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
      const kaydir = (yon) => track.scrollBy({ left: yon * adim() * (window.innerWidth > 989 ? 2 : 1), behavior: azHareket() ? 'auto' : 'smooth' });
      prev && prev.addEventListener('click', () => kaydir(-1));
      next && next.addEventListener('click', () => kaydir(1));
      const durum = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        s.classList.toggle('is-scrollable', max > 2);
        const bar = s.querySelector('[data-slider-progress]');
        if (bar) bar.style.setProperty('--p', max > 0 ? Math.min(1, track.scrollLeft / max) : 1);
      };
      track.addEventListener('scroll', () => requestAnimationFrame(durum), { passive: true });
      window.addEventListener('resize', durum);
      durum();
    });
  };

  const baslat = () => {
    headerKur();
    balonIzle();
    duyuruKur();
    Tema.belirmeKur();
    Tema.kaydiriciKur();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();

  // Theme editor: bölüm yeniden yüklenince kur
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-header]')) { headerKur(); balonIzle(); }
    if (e.target.querySelector('[data-announcement]')) duyuruKur();
    Tema.belirmeKur(e.target);
    Tema.kaydiriciKur(e.target);
  });
})();
